import "./Header.css";
import LogoHeader from '../../Assets/Images/logo-phl-login-page-update.svg.png';
import { navigateToNewTabExternal } from "../../Services/service";
export default function Header() {
    return (
        <header className="header-customer">
            <div className="col-md-6 col-start">
                <img src={LogoHeader} onClick={()=>{localStorage.clear(); navigateToNewTabExternal("/")}}/>
            </div>
            {/* <div className="col-md-6 col-end">
                <span className="description-large-customer">Hotline: <span>(028) 3873 2189</span></span>
            </div> */}
            {/* <CustomChangeLanguage /> */}
        </header>
    )
};
